import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import axios from "axios";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";

import Grid from "@material-ui/core/Grid";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import { Link, Redirect } from "react-router-dom";

import { api_url, version_app } from "../../../js_assets/ConfigApp";
import { withRouter } from "react-router";

import Hammer from "react-hammerjs";
import { isIOS, isMobile } from "react-device-detect";

const styles = {
  root: {
    flexGrow: 1,
    color: "black",
  },
  grow: {
    flexGrow: 5,
  },
  menuButton: {
    marginLeft: 0,
    marginRight: 0,
    color: "white",
  },
  list: {
    width: 250,
  },
  nested: {
    paddingLeft: 250,
  },
  link: {
    textDecoration: "none",
  },
  infoIcon: {
    fontSize: 18,
  },
  ListItemTextFont: {
    fontSize: 15,
  },
  divider: {
    width: "100%",
  },
  isIOSMargintop: {
    marginTop: 15,
  },
};

class AppAdminContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: true,
      anchorEl: null,
      Drawer: false,
      Guide_ListExpand: false,
      Open_DialogContent_User_Info: false,
      Open_DialogContent_User_HealthProfile: false,
      Open_DialogContent_User_Food_Table: false,
      Open_DialogContent_trainer_Active: false,
      loading_state_iocn: false,
      User_Info_Subscription: [],
      Health_Profile_data: {},
      Food_Table_data: {},
      Reset_Password_Form: false,
      error_message_ResetFrom: "",
      trainer_Active_state: false,
      successmessage: false,
      auth_state: true,
      is_loading: true,
    };
  }
  componentDidMount() {
    const { history } = this.props;


    this.check_auth().then((rep) => {

      if (!rep) {
        this.setState({ auth_state: false });
      }

      this.setState({ is_loading: false });
    })



  }



  check_auth = async () => {
    if (JSON.parse(localStorage.getItem("Admin_Info")) != null) {
      return true;
    }
    else {
      return false
    }

  }

  handleChange = (event) => {
    this.setState({ auth: event.target.checked });
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleClick_OpenDrawer = () => {
    this.setState({
      Drawer: true,
    });
  };

  handleClose_Drawer = () => {
    this.setState({ Drawer: false });
  };

  handle_Guide_ListExpand = () => {
    this.setState((state) => ({ Guide_ListExpand: !state.Guide_ListExpand }));
  };

  handleOpen_DialogContent_User_Info = () => {
    const { User_Info_For_trainer } = this.state;
    let Trainer_Info = JSON.parse(localStorage.getItem("Trainer_Info"));

    this.setState({
      loading_state_iocn: true,
      Open_DialogContent_User_Info: true,
    });

    axios
      .get(
        `${api_url}/api/trainer/Get_Subscription_Schedule_User_with_trainer/${User_Info_For_trainer.userId}/${Trainer_Info.TrainerID}`
      )
      .then((result) =>
        this.setState({
          User_Info_Subscription: result.data,
          loading_state_iocn: false,
        })
      )
      .catch(function (error) {
        //console.log(error);
      });

    this.setState({ loading_state_iocn: false });
  };

  redirectToRatingLogin = () => {
    localStorage.clear();

    this.props.history.push("/Admin/AdminLogin");
  };

  redirectToUrl = (Component) => {
    window.location.href =
      window.location.protocol +
      "//" +
      window.location.hostname +
      ":" +
      window.location.port +
      Component;
  };

  render() {
    const { classes, Title } = this.props;
    const { anchorEl } = this.state;

    let ListData = [
      {
        text_list: "المدربين",
        link_list: "/Admin/Trainers",
        img_list: "/assets/imags/app_icon/teamwork.svg",
      },
      {
        text_list: "الاشتراكات والجداول",
        link_list: "/Admin/AdminSubscriptionSchedule",
        img_list: "/assets/imags/app_icon/teamwork.svg",
      },
      {
        text_list: "كود استشاره مجانية",
        link_list: "/Admin/AdminCpConsulting",
        img_list: "/assets/imags/app_icon/teamwork.svg",
      },
      {
        text_list: "العملاء",
        link_list: "/Admin/AdminUser",
        img_list: "/assets/imags/app_icon/teamwork.svg",
      },
      {
        text_list: "الطلبات",
        link_list: "/Admin/AdminListOrders",
        img_list: "/assets/imags/app_icon/clipboard.svg",
      },
      {
        text_list: "الاشعارات",
        link_list: "/Admin/Notfications",
        img_list: "/assets/imags/app_icon/clipboard.svg",
      },
      {
        text_list: "الاحصائيات",
        link_list: "/Admin/SubsCount",
        // img_list: "/assets/imags/app_icon/clipboard.svg",
      },
      {
        text_list: "مدرب جديد",
        link_list: "/Admin/TrainerProfile?TrainerID=New",
        img_list: "/assets/imags/app_icon/man.svg",
      },
      {
        text_list: " دليل المطاعم والمتاجر",
        link_list: "/Admin/AdminProteinGuide",
        img_list: "/assets/imags/app_icon/route.svg",
      },
      {
        text_list: "اكواد الخصم",
        link_list: "/Admin/DiscountCode",
        img_list: "/assets/imags/app_icon/free.svg",
      },
      {
        text_list: " تحتاج فزعة ؟",
        link_list: "/Admin/ListContactUsUser",
        img_list: "/assets/imags/app_icon/call.svg",
      },
      {
        text_list: " الدورات",
        link_list: "/Admin/AdminCourse",
        img_list: "/assets/imags/app_icon/mentorship.svg",
      },
      // {
      //     text_list: ' متاجر بروتين',
      //     link_list: '/Admin/AdminStore',
      //     img_list: '/assets/imags/app_icon/store.svg'
      // },
      // {
      //     text_list: ' محفظة المتاجر',
      //     link_list: '/Admin/AdminCpStoreWallet',
      //     img_list: '/assets/imags/app_icon/store.svg'
      // },
    ];

    let Admin_Info = JSON.parse(localStorage.getItem("Admin_Info"));

    const sideList = (
      <div className={classes.list}>
        <List>
          <div>
            <label> هلا بك: </label>

            <label> {Admin_Info !== null ? Admin_Info.admin_Name : ""} </label>
            <br></br>
            <label> النسخة: </label>

            <span> {version_app}</span>
          </div>

          <div>
            {ListData.map((item) => {
              return (
                <ListItem button>
                  <Link className={classes.link} to={item.link_list}>
                    <ListItemIcon>
                      {/* <img className="sidenavitemimg" src={item.img_list} /> */}
                      <ListItemText>
                        <label className={classes.ListItemTextFont}>
                          {item.text_list}
                        </label>
                      </ListItemText>
                    </ListItemIcon>
                  </Link>
                </ListItem>
              );
            })}

            <ListItem>
              <ListItemIcon onClick={() => this.redirectToRatingLogin()}>
                {" "}
                <img
                  className="sidenavitemimg"
                  src="/assets/imags/app_icon/exit.svg"
                  height={35}
                  width={35}
                />
                <ListItemText>
                  <label className={classes.ListItemTextFont}>خروج</label>
                </ListItemText>
              </ListItemIcon>
            </ListItem>
          </div>
        </List>
      </div>
    );

    if (this.state.is_loading) {

      return <MenuIcon />

    }

    if (this.state.auth_state) {
      return (
        <div className={classes.root}>
          <AppBar position="fixed" style={{ height: 40, backgroundColor: "transparent", borderColor: "white", border: 2 }}>
            <Toolbar style={{ minHeight: 30 }}>

              <MenuIcon onClick={this.handleClick_OpenDrawer} />

              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
                className={classes.root}
              >
                <h4 className={classes.root}>{Title}</h4>
              </Grid>
            </Toolbar>
          </AppBar>

          <Drawer
            anchor="right"
            open={this.state.Drawer}
            onClose={this.handleClose_Drawer}
          >
            <div>{sideList}</div>
          </Drawer>

          <div >
            {this.props.children}
          </div>
        </div>
      );
    } else {
      return <Redirect to="/Admin/AdminLogin" />;
    }
  }
}
AppAdminContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(AppAdminContainer));
